import getGlobalSettingsAccountMailboxInfo from 'owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo';
import { isCapabilityEnabled } from 'owa-capabilities';
import { headerTeamsChatCapability } from 'owa-capabilities-definitions/lib/headerTeamsChatCapability';
import { teamsPoliciesCapability } from 'owa-capabilities-definitions/lib/teamsPoliciesCapability';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { lazyIsTeamsChatEnabled } from 'owa-teams-policies';
import { TeamsPoliciesScenario } from 'owa-teams-policies-store/lib/store/schema';
import { isBrowserSafari } from 'owa-user-agent';

export default async function isTeamsChatButtonEnabled(): Promise<boolean> {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();

    if (
        isCapabilityEnabled(teamsPoliciesCapability, mailboxInfo) &&
        !isGlobalFeatureEnabled('mon-hide-chat-integration') &&
        !isBrowserSafari()
    ) {
        return lazyIsTeamsChatEnabled.importAndExecute(
            TeamsPoliciesScenario.MailEmbedChat,
            mailboxInfo
        );
    }

    return isCapabilityEnabled(headerTeamsChatCapability, mailboxInfo);
}
